import React from 'react';

const CATEGORY_OPTIONS = [
  { value: 'general', label: 'General' },
  { value: 'billing', label: 'Facturacion' },
  { value: 'technical', label: 'Soporte tecnico' },
  { value: 'incident', label: 'Incidencia' },
  { value: 'improvement', label: 'Mejora / sugerencia' },
];

const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Baja' },
  { value: 'medium', label: 'Media' },
  { value: 'high', label: 'Alta' },
];

const TYPE_OPTIONS = [
  { value: 'support', label: 'Consulta / soporte' },
  { value: 'bug', label: 'Reporte de error' },
];

export default function CreateTicketForm({
  values = {},
  onChange,
  onSubmit,
  submitting = false,
  error = '',
  success = '',
}) {
  const { subject = '', description = '', category = 'general', priority = 'medium', ticketType = 'support' } =
    values;

  return (
    <form className="support-form" onSubmit={onSubmit}>
      <div className="support-form-grid">
        <div className="support-form-group">
          <label htmlFor="support-subject">Asunto</label>
          <input
            id="support-subject"
            name="subject"
            value={subject}
            onChange={onChange}
            maxLength={200}
            required
          />
          <p className="support-form-help">Explica brevemente el tema del ticket.</p>
        </div>

        <div className="support-form-group">
          <label htmlFor="support-ticketType">Tipo</label>
          <select
            id="support-ticketType"
            name="ticketType"
            value={ticketType}
            onChange={onChange}
            required
          >
            {TYPE_OPTIONS.map(option => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="support-form-group">
          <label htmlFor="support-category">Categoria</label>
          <select
            id="support-category"
            name="category"
            value={category}
            onChange={onChange}
          >
            {CATEGORY_OPTIONS.map(option => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="support-form-group">
          <label htmlFor="support-priority">Prioridad</label>
          <select
            id="support-priority"
            name="priority"
            value={priority}
            onChange={onChange}
          >
            {PRIORITY_OPTIONS.map(option => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="support-form-group">
        <label htmlFor="support-description">Descripcion</label>
        <textarea
          id="support-description"
          name="description"
          value={description}
          onChange={onChange}
          rows={6}
          maxLength={4000}
          required
        />
        <p className="support-form-help">
          Incluye pasos para reproducir el problema o cualquier referencia adicional que nos ayude a entender el
          contexto.
        </p>
      </div>

      {error ? <div className="support-alert error">{error}</div> : null}
      {success ? <div className="support-alert success">{success}</div> : null}

      <div className="support-form-actions">
        <button type="submit" className="support-primary" disabled={submitting}>
          {submitting ? 'Enviando...' : 'Enviar ticket'}
        </button>
      </div>
    </form>
  );
}
